import { Controller } from "@hotwired/stimulus";

export class ConversationSearchController extends Controller {
  static targets = ["input", "form"];
  static values = {
    vacanciesPanel: String,
    applicantsPanel: String,
    vacanciesPlaceholder: String,
    applicantsPlaceholder: String,
  };

  switchPanel(event) {
    const panel = event.currentTarget.dataset.conversationSearchPanelParam;
    if (!panel) return;

    const panelId =
      panel === "applicants"
        ? this.applicantsPanelValue
        : this.vacanciesPanelValue;
    const placeholder =
      panel === "applicants"
        ? this.applicantsPlaceholderValue
        : this.vacanciesPlaceholderValue;

    this.formTarget.setAttribute("hx-target", `#${panelId}`);
    this.formTarget.setAttribute("hx-vals", JSON.stringify({ panel }));
    this.inputTarget.placeholder = placeholder;
    this.inputTarget.value = "";

    if (window.htmx) {
      window.htmx.process(this.inputTarget);
      window.htmx.process(this.formTarget);
    }
  }
}
